'use strict';
class Bazaarvoice {
  constructor() {
    this.container = document.querySelector('.productReviewsSection [data-bv-show="reviews"]');
    if (!this.container) return;
    this.watchReviewWidgetInitialization();
  }

  init() {
    this.root = document.querySelector('#bv_review_maincontainer');
    if (!this.root) return;
    this.customerModalEvents();
  }

  customerModalEvents() {
    const userButtonAct = document.querySelectorAll('.bv-rnr-action-bar');
    userButtonAct.forEach((usb) => {
      usb.addEventListener('click', this.modalSetAttributes.bind(this));
    });
  }

  modalSetAttributes() {
    setTimeout(() => {
      const reviewModal = this.container.querySelector('#photoModal');
      const reviewModalCloseButton = reviewModal.querySelector('.modalCloseBtn');
      const bvReviewTitle = reviewModal.querySelector('.bv-review-title');
      const reviewModalRating = reviewModal.querySelector('bv-secondary-rating').shadowRoot;
      const reviewGeneralRating = reviewModal.querySelector('bv-ratings').shadowRoot;
      const reviewModalUserName = reviewModal.querySelector('#bv-userprofile-username-header');
      if (reviewModal) {
        reviewGeneralRating.querySelector('.bv-ratings-abbr').setAttribute('aria-hidden', 'false');
        reviewGeneralRating
          .querySelector('.bv-ratings-abbr')
          .setAttribute('title', '5 out of 5 stars rating');
        reviewModal.setAttribute('aria-label', 'Customer Review');
        bvReviewTitle.setAttribute('role', 'heading');
        bvReviewTitle.setAttribute('aria-level', 2);
        reviewModalUserName.setAttribute('role', 'heading');
        reviewModalUserName.setAttribute('aria-level', 2);
        reviewModalRating.querySelectorAll('.srs-role').forEach((el) => {
          const reviewRating = el.querySelector('.srs-badge-rating');
          const ratingTextElement = document.createElement('p');
          el.removeAttribute('role');
          ratingTextElement.textContent = `${reviewRating.textContent} Out of 5 stars Quality rating`;
          el.insertBefore(ratingTextElement, reviewRating);
          ratingTextElement.setAttribute('style', 'width:0;height:0;overflow:hidden;');
        });
      }
      if (reviewModal && reviewModalCloseButton) {
        reviewModalCloseButton.setAttribute('aria-label', 'Close modal');
      }
    }, 1000);
  }

  watchReviewWidgetInitialization() {
    const viewportHeight = Math.floor((window.innerHeight * 10) / 100) + 'px';
    console.log(viewportHeight);
    const config = {
      root: null,
      rootMargin: '0px 0px 0' + viewportHeight + ' 0px',
      threshold: 0.05,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        const section = entries[0].target;
        setTimeout(() => {
          observer.unobserve(section);
        }, 1000);
        // observer.unobserve(section);
        setTimeout(this.init.bind(this), 2000);
      }
    }, config);

    observer.observe(this.container);
  }
}

window.addEventListener('DOMContentLoaded', (evt) => {
  new Bazaarvoice();
});
